export default __webpack_public_path__ + "static/media/header-YoTW@2x.fa0ebced.png";